import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Home from './views/Home.vue';
import Results from './views/Results.vue';
import Gym from "./views/Gym.vue";
import GymRegister from './views/GymRegister.vue';
import PageNotFound from './views/PageNotFound.vue';
import store from './store';

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/gyms-near-me',
            name: 'home',
            component: Home,
        },
        {
            path: '/',
            name: 'home',
            redirect: '/gyms-near-me',
            component: Home,
        },
        { 
            path: '/search/:range',
            name: 'search',
            component: Results,
            props(route) {
                return route.query  || {};
            }
        },
        { 
            path: '/gym/:id',
            name: 'gym',
            component: Gym,
        },
        {
            path: '/register',
            name: 'register',
            component: GymRegister,
        },
        {
            path: '/404',
            name: '404',
            component: PageNotFound
        },
        {
            path: '*',
            redirect: '/404'
        }, 
    ]
})

router.beforeEach((to,from,next) => {
    window.scrollTo(0,0)
    if(store.state.facilities){
        if(to.name === "home"){
            store.state.facilities.map((facility) => {
                if (facility.selected) {
                  store.commit("toggleFacility", facility);
                }
              });
        }
    }
    store.state.backToSearchButton = from.name === "search"
    if(to.name === "search"){
        let {page: pageNum} = to.query;
        pageNum = parseInt(pageNum);
        if(pageNum > store.state.numOfPages ){
            next({
                name: "search",
                params: to.params,
                query: {
                    search: to.query.search,
                    page: store.state.numOfPages,
                    facilities: to.query.facilities
                }
            })
        } else if(pageNum < 1) {
            next({
                name: "search",
                params: to.params,
                query: {
                    search: to.query.search,
                    page: 1,
                    facilities: to.query.facilities
                }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})


export default router;
